import { AddBahasaPayload } from "../../../../models/Bahasa";
import { AddDivisiPayload } from "../../../../models/Divisi";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";

import mutationWrapper from "../../mutationWrapper";
import { fetchAllDivisiKey } from "../../queries/Divisi/useFetchAllDivisi";
import getQueryClient from "../../queryClient";

export async function addDivisi(data: AddDivisiPayload) {
  const res = await ApiClient.post(`/AddDivisi`, data);
  return res.data;
}

export const useAddDivisi = mutationWrapper(addDivisi, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAllDivisiKey);
  },
});
